import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronLeft, FiChevronRight, FiStar } from 'react-icons/fi';
import { testimonials } from '../../data/mockData';
import { useHydrated } from '../../hooks/useHydrated';
import { useTranslation } from '../../hooks/useTranslation';
import './Testimonials.css';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const hydrated = useHydrated();
  const { t } = useTranslation();
  const visibleCount = 3;

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev + 1 >= testimonials.length ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev - 1 < 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < visibleCount; i++) {
      const index = (currentIndex + i) % testimonials.length;
      visible.push(testimonials[index]);
    }
    return visible;
  };

  return (
    <section className="testimonials-section section">
      <div className="container">
        <div className="section-title">
          <h2>{t('testimonials.title')}</h2>
          <p>{t('testimonials.subtitle')}</p>
        </div>

        <div className="testimonials-wrapper">
          <button className="nav-btn prev-btn" onClick={prevSlide}>
            <FiChevronLeft />
          </button>

          <div className="testimonials-container">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                className="testimonials-grid"
                initial={hydrated ? { opacity: 0, x: 50 } : false}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.3 }}
              >
                {getVisibleTestimonials().map((testimonial, index) => (
                  <div key={`${testimonial.id}-${index}`} className="testimonial-card">
                    <div className="testimonial-header">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="testimonial-avatar"
                      />
                      <div className="testimonial-info">
                        <h4>{testimonial.name}</h4>
                        <span className="testimonial-location">{testimonial.location}</span>
                      </div>
                    </div>
                    <div className="testimonial-rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <FiStar key={i} className="star-icon" />
                      ))}
                    </div>
                    <p className="testimonial-text">"{testimonial.text}"</p>
                    <span className="testimonial-service">{testimonial.service}</span>
                  </div>
                ))}
              </motion.div>
            </AnimatePresence>
          </div>

          <button className="nav-btn next-btn" onClick={nextSlide}>
            <FiChevronRight />
          </button>
        </div>

        <div className="testimonials-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
